import {Component} from '@angular/core';
import {IMessage, MailService} from '../shared/mail.service';
import {FlashMessagesService} from 'angular2-flash-messages';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent {
    message: IMessage = {};

    constructor(private mailService: MailService, private _flashMessagesService: FlashMessagesService) {
    }

    sendEmail(message: IMessage) {
        this.mailService.sendEmail(message).subscribe(res => {
            this._flashMessagesService.grayOut(true);
            this._flashMessagesService.show('Die Anfrage wurde erfolgreich verschickt.', {
                cssClass: 'alert-success',
                timeout: 3000
            });
        }, error => {
            this._flashMessagesService.grayOut(true);
            this._flashMessagesService.show('Die Anfrage konnte nicht versandt werden.', {
                cssClass: 'alert-danger',
                timeout: 3000
            });
        });
    }
}



// WEBPACK FOOTER //
// /media/webdesign/5E0ECC7B0ECC4E29/www/leasytool/src/app/contact/contact.component.ts